import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Camera, CameraOptions } from '@awesome-cordova-plugins/camera/ngx';
import { CommonService } from 'src/app/common.service';
import { CBXCameraOption, CameraService } from 'src/app/services/mobile/camera/camera.service';

@Component({
  selector: 'app-choose-file-upload',
  templateUrl: './choose-file-upload.component.html',
  styleUrls: ['./choose-file-upload.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChooseFileUploadComponent {
  @Input('acceptFormat') acceptFormat: any = ['image/png', 'image/jpeg', 'image/jpg','application/pdf'];

  file: any;
  constructor(private _commonService: CommonService,
    private dialogRef: MatDialogRef<ChooseFileUploadComponent>,
    private _camera: Camera) {
    
  }

  onFileSelected($event) {
    this.setImageData($event.target.files[0]);
  }

  setImageData(imageData) {
    if (typeof (imageData) === 'object') {
      this.file = imageData;
      this.dialogRef.close(imageData);
    } else {
      let blob = this._commonService.base64ToBlob(imageData);
      if(blob.size > 1000000){
        this._commonService.scaleDownImage(imageData, 768).then(
          (imgBase64) => {  
            this.file = this._commonService.base64ToBlob(imgBase64);
            this.file['name'] = 'image.'+this.file.type?.split('/')?.[1];
            this.dialogRef.close(this.file);
          }
        );
      } else {
        this.file = this._commonService.base64ToBlob(imageData);
        this.file['name'] = 'image.'+this.file.type?.split('/')?.[1];
        this.dialogRef.close(this.file);
      }
    }
  }

  startCamera() {
    let options: CameraOptions = {
      quality: 100,
      targetWidth: 1024,
      targetHeight: 1024,
      destinationType: this._camera.DestinationType.DATA_URL,
      encodingType: this._camera.EncodingType.JPEG,
      mediaType: this._camera.MediaType.PICTURE,
      sourceType: this._camera.PictureSourceType.CAMERA,
      cameraDirection: this._camera.Direction.FRONT,
      correctOrientation: true
    }
    this._camera.getPicture(options).then(
      (imageData) => {
        this.setImageData("data:image/jpeg;base64," + imageData);
      }
    )
  }

  private swipeCoord?: [number, number];
  private swipeTime?: number;

  swipe(e: TouchEvent, when: string): void {
    const coord: [number, number] = [e.changedTouches[0].clientX, e.changedTouches[0].clientY];
    const time = new Date().getTime();

    if (when === 'start') {
      this.swipeCoord = coord;
      this.swipeTime = time;
    } else if (when === 'end') {
      const direction = [coord[0] - this.swipeCoord[0], coord[1] - this.swipeCoord[1]];
      const duration = time - this.swipeTime;

      if (duration < 2000 //
        && Math.abs(direction[1]) > 20
        && Math.abs(direction[1]) > Math.abs(direction[0] * 3)) {
          const swipe = direction[1] < 0 ? 'up' : 'down';
          console.log(swipe);
          if(swipe == 'down') {
            this.dialogRef.close();
          }
      }
    }
  }
}
